import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";

interface QuoteBlockProps {
  quote: string;
  role?: string;
}

const Blockquote = styled("blockquote")(({ theme }) => ({
  borderLeft: `2px solid ${theme.palette.primary.main}`,
  paddingLeft: theme.spacing(2),
  marginLeft: 0,
  marginRight: 0,
  marginTop: theme.spacing(1.5),
  marginBottom: theme.spacing(1.5),
}));

const RoleLabel = styled(Typography)({
  marginTop: "2px",
  display: "block",
});

export function QuoteBlock({ quote, role }: QuoteBlockProps) {
  if (!quote) return null;
  return (
    <Blockquote>
      <Typography variant="caption" color="text.secondary" fontStyle="italic">
        {quote}
      </Typography>
      {role && (
        <RoleLabel variant="caption" color="text.disabled">
          {role}
        </RoleLabel>
      )}
    </Blockquote>
  );
}
